import JsonApi from "../../api/jsonApi";
import {Feature} from "../../interfaces/Feature";
import {AxiosResponse} from "axios";
import {Dispatch} from "redux";
import {RootState} from "../../interfaces/Global";
import {CartItem} from "../../interfaces/CartItem";

let _pricingGridPresets: PricingGridPreset[] = [{
  columnHeaders: [], priceTable: [], rowHeaders: [], settings: {
    currency: "USD", mode: "RetailPrice", visualizerType: "", version: 1,
  },
}];

export const getFeaturesPriceTable = () => {
  return async (dispatch: Dispatch, getState: () => RootState): Promise<any> => {
    if (!getState().fabricatorState.settings.enablePriceGrid) {
      return
    }
    return JsonApi.getFeaturesPriceTable()
      .then((response: AxiosResponse) => {
        if (!response || !Array.isArray(response.data) || !response.data[0] || !response.data[0].priceTable) {
          return
        }
        if (Array.isArray(response.data)) {
          _pricingGridPresets = response.data.map(pricingGrid => {
            if (pricingGrid?.rowHeaders) {
              pricingGrid.rowHeaders = pricingGrid.rowHeaders.map(header => {
                header.featuresRequired = header.featureData.filter(f => f.isRequired);
                return header
              });
            }
            if (pricingGrid?.columnHeaders) {
              pricingGrid.columnHeaders = pricingGrid.columnHeaders.map(header => {
                header.featuresRequired = header.featureData.filter(f => f.isRequired);
                return header
              });
            }
            if (pricingGrid?.gridMarkUp && typeof pricingGrid.gridMarkUp === "string") {
              pricingGrid.gridMarkUp = JSON.parse(pricingGrid.gridMarkUp);
            }
            return pricingGrid
          });
        }
        console.log("getFeaturesPriceTable _pricingGridPresets", _pricingGridPresets);
        // dispatch(restorePaymentInfo(Misc.parseShippingAndBillingResponse({
        //   shippingAddress: response.data,
        // })))
      })
      .catch(error => error)
  }
}

const pricingGridHeaderHasAddedCardItem = (header: PricingGridHeader, storeState: RootState, forQuoteIndex?: number|undefined) => {
  const activeQuoteIndex = Number.isInteger(forQuoteIndex) ? forQuoteIndex : storeState.quotesState.activeQuoteIndex;
  const currentRoomCartItems = storeState.cartState.cartItems.filter(cartItem => {
    return cartItem.currentQuote === activeQuoteIndex
  })
  const cartSharedNames = new Set(
    currentRoomCartItems.map(
      (cartItem: CartItem) => cartItem.cartFeature.dbFeature.sharedFeatureName
    )
  )
  if (header.featuresRequired.length > 0) {
    if (!header.featuresRequired.some((f) => cartSharedNames.has(f.sharedFeatureName))) {
      return false
    }
    // 2 conditions, first at least one required should be checked, at least one not required should be checked as well
    return header.featureData.some((f) => {
      return !f.isRequired && cartSharedNames.has(f.sharedFeatureName)
    })
  }
  return header.featureData.some((f) => cartSharedNames.has(f.sharedFeatureName))
}

export const getPricingGridFeaturePrice = (
  feature: Feature,
  storeState: RootState,
  forQuoteIndex?: number|undefined,
  useCostTable?: boolean
) : {
  priceFromGrid: number | null;
  gridMarkUp?: PricingGridPreset["gridMarkUp"]
} => {
  if (!feature.dbFeature.sku || !storeState.cartState.cartItems.length) {
    return {priceFromGrid: null}
  }
  const pricingGrid = useCostTable ?? storeState.fabricatorState.settings.useFabricatorCostPrices
    ? _pricingGridPresets[1]
    : _pricingGridPresets[0];
  if (!pricingGrid) {
    return {priceFromGrid: null}
  }
  const existingRecords: PricingGridTableItem[] = pricingGrid.priceTable.filter(record => {
    return record.sku === feature.dbFeature.sku
  })
  let newPrice: number | null = null;
  let priceWasSetFrom = "";
  if (!existingRecords.length) {
    return {priceFromGrid: null}
  }
  existingRecords.forEach((existingRecord: PricingGridTableItem) => {
    if (priceWasSetFrom) {
      return
    }
    existingRecord.tableData.forEach((tableRow: PricingGridTableItemData) => {
      if (priceWasSetFrom) {
        return
      }
      const columnHeader = pricingGrid.columnHeaders.find((header: PricingGridHeader) => {
        return header.id === tableRow.columnId;
      });
      const rowHeader = pricingGrid.rowHeaders.find((header: PricingGridHeader) => {
        return header.id === tableRow.rowId;
      });
      if (!columnHeader || !rowHeader) {
        return null
      }
      if (!pricingGridHeaderHasAddedCardItem(columnHeader, storeState, forQuoteIndex)) {
        return null
      }
      if (!pricingGridHeaderHasAddedCardItem(rowHeader, storeState, forQuoteIndex)) {
        return null
      }
      priceWasSetFrom = columnHeader.id + " " + rowHeader.id;
      newPrice = tableRow.price;
    })
  })
  return {priceFromGrid: newPrice, gridMarkUp: _pricingGridPresets[0]?.gridMarkUp || null};
};
